import React from "react"
import { Box, Text } from "@chakra-ui/react"
import AccordionItem from '../accordion/accordianItem'
import { Accordion } from "@chakra-ui/react"
import { Shipping } from "./shipping"
import { CareInformation } from "./careInformation"
import { EndOfLife } from "./endOfLife"

const ProductAccordian = ({ product, shipping, productMetafields, productInformation, isDesign = false }) => {
  return (
    <Accordion defaultIndex={0} id="productAccordian" width="100%">
      { !isDesign && 
        <AccordionItem id="Details" title="Details">
          <Box width="100%">
            <Text as="h2"
              dangerouslySetInnerHTML={{ __html: `<div> ${product.descriptionHtml} </div>` }}>
            </Text>
          </Box>
        </AccordionItem>
      }
      <AccordionItem title="Care and Info" >
        <CareInformation productInformation={productInformation} productType={productMetafields.care_info} />
      </AccordionItem>
      {/* <AccordionItem title="End of Life" >
        <EndOfLife productInformation={productInformation} productType={productMetafields.care_info} />
      </AccordionItem> */}
      <AccordionItem title="Shipping">
        <Shipping shipping={shipping} />
      </AccordionItem>
      {/* <AccordionItem title="Share this Product">
          <Share />
        </AccordionItem> */}
    </Accordion>
  )
}

export default ProductAccordian
